// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"MR-z","inlineTitle":"NR-z","sponsoredAdsWrapper":"OR-z","marketplaceRecosWrapper":"PR-z"};